import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { OrderAdminNoteAdminType } from '../enums/OrderAdminNoteAdminType'

export class OrderAdminNoteEntity {
  id?: string
  orderId?: string
  note?: string | null
  adminUser?: UserMiniEntity
  adminType?: OrderAdminNoteAdminType
  createdAt?: string
  updatedAt?: string
}
